export default "__VITE_ASSET__D124V_Fl__"